
import * as React from 'react';
import { useState, useEffect, useCallback , useRef}  from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import { app } from '../../config/app.js';
import {  getPermission } from '../../controller/user.js';
import {  getDataByKey } from '../../controller/firestore.js';
import {  getData } from '../../controller/firestore.js';
import { updateDocToDb } from '../../controller/firestore.js';
import {UserCategoryForm} from '../../config/collections/guide.js'; // Adjust the path as necessary

import { Firma } from '../../components/Firma.js';
import dayjs from 'dayjs';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';

import { DateField } from '@mui/x-date-pickers';
import {  Navigate , Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useLocation } from 'react-router-dom';

import Stack from '@mui/material/Stack';
import { Button, ButtonGroup } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ConfirmDialog } from '../../components/Confirm.js';
import { useNavigate } from 'react-router-dom';
import { convertDatetime } from '../../controller/utils.js';



export function CreateGuida(props) {
  const user = props.user;
  const collectionName = "guide";
  const location = useLocation();
  const httpdata = location.state && location.state.data;
  //console.log("HTTP DATA GUIDE: ", httpdata);
  const candidatoData = (httpdata && httpdata.candidato ? httpdata.candidato : null);
  const id = (httpdata && httpdata.id ? httpdata.id : null);
  const category=(candidatoData && candidatoData.categoria ? candidatoData.categoria : (httpdata.docData && httpdata.docData.category?httpdata.docData.category:null));
  const [hasStored,setHasStored]=useState(false);
  const activePermission = getPermission("collection", collectionName, null, user);
  
  const [reloadIstruttori,setReloadIstruttori]=useState(true);
  const [istruttori, setIstruttori] = useState([]);
  const [firmaData, setFirmaData] = useState(null);
  const [openConfirmSaveDialog,setOpenConfirmSaveDialog]=useState(false);
  const confirmSaveModeButtons=[
      {
        name:"save-newGuida-ok",
        text:"Salva",
        callback: async function () {
          
          setOpenConfirmSaveDialog(false);
          saveGuidaClick();
          
        }
      },
      {
        name:"save-newGuida-ko",
        text:"Annulla",
        callback: function () {
          setOpenConfirmSaveDialog(false);
        }
      }
  
    ];


  useEffect(() => {
    const fetchIstruttori = async () => {
      const activePermission=getPermission("collection","utenti",null,user);
      const params={
        //"orderBy":orderBy,
    //    "pageSize":pageSize,
    //    "page":currentPage,
    //    "startAfter":cursor,
        "permission":activePermission,        
        "user":user,
        "where":[
          [ "isIstruttore", "==", 1 ],
          [ "stato", "==", 1 ],
        ]
      };
      try {
        const data = await getData("utenti", app.collections_config["utenti"]["views"]["table"], params);
        const istruttoriMap = {};
        data["body"].forEach(istruttore => {
          
            
          istruttoriMap[istruttore.id] = { nome:istruttore.nome, cognome:istruttore.cognome, nomeBreve:istruttore.nome+' '+istruttore.cognome.substring(0,1) };            
          
        });
        setIstruttori(istruttoriMap);
       // console.log("Istruttori", istruttoriMap);
        setReloadIstruttori(false);
      } catch (error) {
        setErrorMessageHeader("Errore");
        setErrorMessage("Error fetching istruttori: " + error.message);
      }
    };
    if (reloadIstruttori)
    fetchIstruttori();
  }, []);
  const collectionConfig = app.collections_config[collectionName];
  const categoryScheme=collectionConfig.questionCfg.categoryScheme[category];
  const [docGuida, setDocGuida] = useState(
    (httpdata.docData ? httpdata.docData : {
    candidato: candidatoData["id"],
    
    candidatoName: candidatoData["nome"] + " " + candidatoData["cognome"],
    istruttore: "",
    category: category,
    date: dayjs().format('YYYY-MM-DD HH:mm'),
    durata: 60,
    //category: candidatoData.category,
    detail: {

    },
    scheme:categoryScheme
  }));
  const [errorMessage, setErrorMessage] = useState("");
  
  const [errorMessageHeader, setErrorMessageHeader] = useState("");
  const [innerChanged, setInnerChanged] = useState(null);
  const findCandidatoLink = "/candidati/";
  const currentPath = location.pathname;
  
 // console.log("Doc guidadata", docGuida);
  useEffect(() => {
    if (id) {
      // Fetch existing guida data if id is present
      getDataByKey(collectionName, id).then(data => {
        setDocGuida(data);
      }).catch(error => {
        setErrorMessageHeader("Errore");
        setErrorMessage("Error fetching data: " + error.message);
      });
    }
  }, [id]);

  const handleChange = (field, value) => {
    setDocGuida(prevState => ({
      ...prevState,
      [field]: value
    }));
  };
   async function saveGuidaClick() {
    if (!docGuida.istruttore) {
      setErrorMessageHeader("Errore");
      setErrorMessage("Il campo 'Istruttore' non è compilato.");
      return;
    }
    if (!docGuida.date) {
      setErrorMessageHeader("Errore");
      setErrorMessage("Il campo 'Data' non è compilato.");
      return;
    }
    if (!docGuida.durata) {
      setErrorMessageHeader("Errore");
      setErrorMessage("Il campo 'Durata' non è compilato.");
      return;
    }
    if (!docGuida.hasOwnProperty("creationDatetime")) {
      docGuida["creationDatetime"] = dayjs().$d;
      docGuida["creationUser"] = user.uid;
      docGuida["creationUserName"] = user.db.nome+' '+user.db.cognome;
    }
    docGuida["modificationDatetime"] = dayjs().$d;
    docGuida["modificationUser"] = user.uid;
    docGuida["modificationUserName"] = user.db.nome+' '+user.db.cognome;
    docGuida["istruttoreNome"]=istruttori[docGuida.istruttore].nome;
    docGuida["istruttoreCognome"]=istruttori[docGuida.istruttore].cognome;    
    docGuida["istruttoreBreve"]=istruttori[docGuida.istruttore].nomeBreve;
    if (firmaData) {
      firmaData["datetime"]=dayjs(convertDatetime(firmaData.datetime)).$d;
    }
    docGuida["firma"]=firmaData;
    docGuida.date=dayjs(docGuida.date).$d;
    
    docGuida.schemeRaw=JSON.stringify(docGuida.scheme);
    delete docGuida.scheme;
      // Update existing doc
      const esito=await updateDocToDb(collectionName, null,docGuida.id, docGuida);
      if (esito[0]){
        setErrorMessageHeader("Avviso");
        setErrorMessage("Guida aggiornata correttamente");
        console.log("Guida aggiornata correttamente");
        setHasStored(true);
      }
      else {
        const error=esito[1];
        setErrorMessageHeader("Errore");
        setErrorMessage("Errore nell'aggiornamento della guida: " + error.message);
        console.error("Errore nell'aggiornamento della guida: " + error.message);
      };
    
  };
  
  return (
    <div>
      <Dialog
      open={errorMessage !== ""}
      onClose={() => {
        setErrorMessage("");
        setErrorMessageHeader("")
      }
      }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      >
      <DialogTitle id="alert-dialog-title">{errorMessageHeader}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
        {errorMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => { setErrorMessageHeader("");
          setErrorMessage("")}} color="primary" autoFocus>
        Chiudi
        </Button>
      </DialogActions>
      </Dialog>
      {hasStored === true ? (
      <Navigate to="/guide/scheda" state={{ data: { candidato: candidatoData } }} />
      ) : (
      <>
      
      <ConfirmDialog 
                   key={"newGuida-update"} 
                   title='Attenzione' 
                   message='Confermi inserimento della GUIDA a sistema?' 
                   buttons={confirmSaveModeButtons} 
                   onClose={confirmSaveModeButtons[1].callback} 
                   open={openConfirmSaveDialog} 
                   setOpen={setOpenConfirmSaveDialog} 
                   /> 
        <Typography sx={{ mb: 2 }} variant="h4">Nuova Guida</Typography>
        {candidatoData === null ? (
        <Link to={findCandidatoLink} state={{ data: { viewAction: 'singleChoice', callbackViewActionUrl: currentPath } }}>
          Cerca candidato
        </Link>
        ) : (
        <div>
          <Typography  sx={{ mb: 2 }}  variant="h6" component="h6"><b>CANDIDATO: </b> 
          {candidatoData.nome} {candidatoData.cognome} (Cat. {app.category[candidatoData.categoria]})
          </Typography>
          <div>
          <FormControl sx={{ m: 1, minWidth: 300 }}>
            <InputLabel id="guida-istruttore-label">Istruttore *</InputLabel>
            <Select
            labelid="guida-istruttore-label"
            id="guida-istruttore"
            variant="outlined"
            value={docGuida.istruttore}
            onChange={(e) => handleChange('istruttore', e.target.value)}
            label="Istruttore"
            required={true}
            >
            <MenuItem key='' value='' disabled>Non selezionato</MenuItem>
            {Object.entries(istruttori).map(([key, istrObj]) => (

              <MenuItem key={key} value={key}>
              {istrObj.nome} {istrObj.cognome}
              </MenuItem>
            ))}
            </Select>
          </FormControl>
          </div>
          <div>
          <DateTimeField
          sx={{ m: 1 }}
            onChange={(e) => handleChange('date', e.$d)}
            variant="outlined"
            required={true}
            labelid="guida-guida-label"
            id="newguida-date"
            name="date"
            label="Data"
            value={dayjs(docGuida.date)}
          />
          <FormControl sx={{ m: 1 }}>
            <InputLabel id="guida-durata-label">Durata *</InputLabel>
            <Select
            id="guida-durata"
            labelid="guida-durata-label"
            value={docGuida.durata}
            variant="outlined"
            required={true}
            onChange={(e) => handleChange('durata', e.target.value)}
            >
            {Object.entries(app.durate).map(([key, label]) => (
              <MenuItem key={key} value={key}>
              {label}
              </MenuItem>
            ))}
            </Select>
          </FormControl>
          </div>
          <UserCategoryForm guida={docGuida} changeGuidaObj={setDocGuida} candidato={candidatoData} mode="edit" />
          <div>
            <Typography variant="h6" component="h6">Note</Typography>
            <TextField
                variant="outlined"
                value={docGuida.note}
                onChange={(e) => handleChange('note', e.target.value)}
                label=""
                
                multiline
                rows={4}
                fullWidth
            />
        </div>
        <div>
            <Typography variant="h6" component="h6" sx={{ mt: 5 }}>Firma candidato</Typography>
            <Firma firmaData={firmaData} setFirmaData={setFirmaData} user={user} modify={true}></Firma>
        </div>
          <ButtonGroup sx={{ mt: 5 }} variant="contained" aria-label={`button group`}>
          <Button
            sx={{ fontSize: '20px', padding: '10px 20px' }}
            variant='contained'
            color='success'
            onClick={() => setOpenConfirmSaveDialog(true)}
          >
            {id == null ? "Salva" : "Modifica"}
          </Button>
          </ButtonGroup>
        </div>
        )}
      </>
      )}
    </div>
    );
}
